module.exports = __webpack_public_path__ + "static/media/card-error.0ff0ed5b.svg";